import * as actionTypes from "./actionTypes";

export interface IPatternParams {
  layerType: string;
  sourceId: number;
}

export enum LayerType {
  EXT = "EXT",
  LND = "LND",
  STG = "STG",
  HSTG = "HSTG",
  PROV = "PROV"
}

export interface IPatterns {
  [key: string]: IExtractorPatterns[];
}

export interface IExtractorPatterns {
  etlPatternId: string;
  patternName: string;
  defaultSelection: string;
  patternType: string;
  tableType: string;
}

export interface IPatternsState {
  pending: boolean;
  patterns?: IPatterns | null;
  error?: IApiError | null;
}

export interface IApiError {
  errorCode: Number;
  errorType: string;
  detail: string;
  instance: string;
  traceId: string;
}

export interface FetchPatternsSuccessPayload {
  layerType: string;
  patterns: IExtractorPatterns[];
}

export interface FetchPatternsFailurePayload {
  error: IApiError;
}

export interface FetchPatternsReq {
  type: typeof actionTypes.FETCH_PATTERNS_REQUEST;
  params: IPatternParams;
}

export type FetchPatternsSuccess = {
  type: typeof actionTypes.FETCH_PATTERNS_SUCCESS;
  payload: FetchPatternsSuccessPayload;
};

export type FetchPatternsFailure = {
  type: typeof actionTypes.FETCH_PATTERNS_FAIL;
  payload: FetchPatternsFailurePayload;
};

export type PatternsActions =
  | FetchPatternsReq
  | FetchPatternsSuccess
  | FetchPatternsFailure;

export interface IExtPattern {
  selectedPatternId: string;
  insertDateTime: string;
}

export interface IPattern {
  selectedPatternId: string;
}

// Custom
export interface IColumns {
  name: string;
  dataType: string;
  maxLength: number;
  precision: number;
  scale: number;
  ordinalPosition: number;
}

export interface ICustomExtParams {
  sourceId: number;
  platformGroup: string;
  userEmail: string;
  extPattern: IExtPattern;
  lndPattern: IPattern;
  stgPattern: IPattern;
  hstgPattern: IPattern;
  entities: S3Entities[]
}

export interface S3Entities {
  schema: string,
  name: string,
  type: string,
  mappingAttribute: string,
  customSql: string | null,
  columns: IColumns[],
  fileRegistration: IFileRegistration | null
}

export interface IFileRegistration {
  blobContainer?: string,
  fieldDelimeter?: string,
  extension?: string,
  isHeader?: boolean,
  manifestFileFlag?: string,
  wildcardExpression?: string,
  fileName?: string,
  folderName?: string,
  deleteFlag?: string,
  textDelimiter?: string,
  escapeChar?: string
}


export interface ICustomExtState {
  pending: boolean;
  extractor?: ICustExtSuccess[] | null;
  error?: IApiError | null;
}

export interface ICustExtSuccess {
  entityName: string;
  batchCode: string;
  isSuccess: true;
  errorMessage: string;
  layerType: string;
  extSchema: string;
}

export interface IPostCustomExtSuccessPayload {
  customExtStatus: ICustExtSuccess[];
}



export interface IPostCustomExtFailurePayload {
  error: IApiError;
}

export type PostCustomExtRequest = {
  type: typeof actionTypes.POST_CUSTOMEXT_REQUEST;
  payload: ICustomExtParams;
};

export type PostCustomExtReset = {
  type: typeof actionTypes.POST_CUSTOMEXT_RESET;
}

export type PostCustomExtSuccess = {
  type: typeof actionTypes.POST_CUSTOMEXT_SUCCESS;
  payload: IPostCustomExtSuccessPayload;
};

export type PostCustomExtFailure = {
  type: typeof actionTypes.POST_CUSTOMEXT_FAILURE;
  payload: IPostCustomExtFailurePayload;
};

export type PostCustomExtractorActions =
  | PostCustomExtRequest
  | PostCustomExtReset
  | PostCustomExtSuccess
  | PostCustomExtFailure;

//DB Extractor

export interface IEntities {
  schema: string;
  name: string;
  type: string;
  mappingAttribute: string | null;
}

export interface IDBExtParams {
  sourceId: number;
  platformGroup: string;
  userEmail: string;
  extPattern: IExtPattern;
  lndPattern: IPattern;
  stgPattern: IPattern;
  hstgPattern: IPattern;
  entities: IEntities[];
}

export interface IDBExtSuccess {
  entityName: string;
  batchCode: string;
  isSuccess: true;
  errorMessage: string;
}

export interface IDBExtState {
  pending: boolean;
  extractor?: IDBExtSuccess[] | null;
  error?: IApiError | null;
}

export interface IPostDBExtSuccessPayload {
  dbExtStatus: IDBExtSuccess[];
}

export interface IPostDBExtFailurePayload {
  error: IApiError;
}

export type PostDBExtRequest = {
  type: typeof actionTypes.POST_DBEXT_REQUEST;
  payload: IDBExtParams;
};

export type PostDBExtReset = {
  type: typeof actionTypes.POST_DBEXT_RESET;
}

export type PostDBExtSuccess = {
  type: typeof actionTypes.POST_DBEXT_SUCCESS;
  payload: IPostDBExtSuccessPayload;
};

export type PostDBExtFailure = {
  type: typeof actionTypes.POST_DBEXT_FAILURE;
  payload: IPostDBExtFailurePayload;
};

export type PostMetaDataDBExtActions =
  | PostDBExtRequest
  | PostDBExtReset
  | PostDBExtSuccess
  | PostDBExtFailure;


export interface IDataExtractorList {
  count: number;
  extractors: IDataExtractor[];
}


export interface IDataExtractor {
  sourceId: string,
  sourceName: string,
  batchCode: string,
  tableId: string,
  table: string,
  schema: string,
  owner: string,
  description: string,
  dataStewards: string,
  datasetName: string,
  securityClassification: string,
  privacyClassification: string,
  treatmentLevel: string,
  manualTreatment: string,
  accessControl: string,
  createdOn: string,
  grantees: string,
  updatedOn: string,
  lastRefreshDate: string,
  spokeName: string,
  taskId: string,
  enabled: boolean,
  columnTreatment: string
}


export interface IDataExtractorDetails {
  sourceId: string,
  batchCode: string,
  tableId: string,
  table: string,
  schema: string,
  owner: string,
  description: string,
  dataStewards: string,
  datasetName: string,
  securityClassification: string,
  privacyClassification: string,
  treatmentLevel: string,
  manualTreatment: string,
  accessControl: string,
  createdOn: string,
  updatedOn: string,
  lastRefreshDate: string
}

export interface ExtractorListState {
  pending: boolean;
  extractors: IDataExtractorList;
  error?: IApiError | null;
}

export interface FetchExtractorListSuccessPayload {
  extractors: IDataExtractorList;
}

export interface FetchExtractorListFailurePayload {
  error: IApiError;
}

export interface FetchExtractorListReq {
  type: typeof actionTypes.FETCH_EXTRACTOR_LIST_REQUEST;
  params: IExtractorListParams;
}

export interface IExtractorListParams {
  top: number,
  skip: number,
  count: boolean,
  search: string | null,
  schema?: string[],
  table?: string[],
  treatmentLevel?: string[],
  accessControl?: string[],
  sourceName?: string[],
  orderby?: string,
  owner?: string[],
  dataStewards?: string[],
  spokeName?: string[],
  nonUdlTables?: boolean,
}

export type FetchExtractorListSuccess = {
  type: typeof actionTypes.FETCH_EXTRACTOR_LIST_SUCCESS;
  payload: FetchExtractorListSuccessPayload;
};

export type FetchExtractorListFailure = {
  type: typeof actionTypes.FETCH_EXTRACTOR_LIST_FAILURE;
  payload: FetchExtractorListFailurePayload;
};

export type ExtractorListActions =
  | FetchExtractorListReq
  | FetchExtractorListSuccess
  | FetchExtractorListFailure;



// GET EXTRACTOR DETAILS

export interface IExtractorDetailState {
  pending: boolean;
  extractorDetail?: ISingleExtractorDetail | null;
  error?: IApiError | null;
}

export interface ISourceLayer {
id: number,
name: string
}

export interface ISingleExtractorDetail {
  lastRefreshDate: string,
  createdBy: string,
  tableId: string,
  table: string,
  createdOn: string,
  lastUpdatedBy: string,
  lastModifiedOn: string,
  businessMetadata: IBusinessMetadata,
  columnGovernanceMetadata: IColumnGovernance[],
  extPattern: IExtDataPattern,
  lndPattern: ILndDataPattern,
  stgPattern: IStgDataPattern,
  hstgPattern: IHisDataPattern,
  mappingAttributes: string,
  fileRegistration: IFileRegistration,
  customSql: string,
  sourceLayer: ISourceLayerMetadata,
  criticality: string
}

export interface IBusinessMetadata {
  name: string,
  description: string,
  schema: string,
  dataStewards: string,
  dataSetName: string,
  securityClassification: string,
  privacyClassification: string,
  accessControls: string[],
  tableName: string,
  treatmentLevel: string
}

export interface IColumnGovernance {
  srcId: string,
  tableId: string,
  columnId: string,
  ordinal: 0,
  securityClassification: string,
  privacyClassification: string,
  treatmentLevel: string,
  manualTreatment: string
}

export interface IExtDataPattern {
  selectedPatternId: string,
  businessDateTime: string,
  insertDateTime: string
}

export interface ILndDataPattern {
  selectedPatternId: string
}

export interface IHisDataPattern {
  selectedPatternId: string
}

export interface IStgDataPattern {
  selectedPatternId: string
}

export interface ISourceLayerMetadata {
  id: string,
  name: string,
  layerType?: string
}

export interface ISingleExtractorParams {
  batchCode: string;
}

// FETCH EXTRACTOR DETAILS

export interface FetchExtractorDetailSuccessPayload {
  extractorDetail: ISingleExtractorDetail;
}

export interface FetchExtractorDetailFailurePayload {
  error: IApiError;
}

export interface FetchExtractorDetailReq {
  type: typeof actionTypes.FETCH_EXTRACTOR_DETAIL_REQUEST;
  params: string;
}

export type FetchExtractorDetailSuccess = {
  type: typeof actionTypes.FETCH_EXTRACTOR_DETAIL_SUCCESS;
  payload: FetchExtractorDetailSuccessPayload;
};

export type FetchExtractorDetailFailure = {
  type: typeof actionTypes.FETCH_EXTRACTOR_DETAIL_FAILURE;
  payload: FetchExtractorDetailFailurePayload;
};

export type ExtractorDetailActions =
  | FetchExtractorDetailReq
  | FetchExtractorDetailSuccess
  | FetchExtractorDetailFailure;

// DELETE EXTRACTOR

export interface IDeleteExtractorState {
  pending: boolean;
  deleteStatus?: IDeleteExtractorSuccess[] | null;
  error?: IApiError | null;
}
export interface IDeleteExtractorSuccess {
  batchCode: string,
  isDeleted: boolean,
  error: string
}

export interface IDeleteExtractorSuccessPayload {
  deleteStatus: IDeleteExtractorSuccess[];
}

export interface IDeleteExtractorFailurePayload {
  error: IApiError;
}


export interface IDeleteParams {
  batchCodes: string[],
}

export type DeleteExtractorRequest = {
  type: typeof actionTypes.DELETE_EXTRACTOR_REQUEST;
  payload: IDeleteParams;
}

export type DeleteExtractorSuccess = {
  type: typeof actionTypes.DELETE_EXTRACTOR_SUCCESS;
  payload: IDeleteExtractorSuccessPayload;
};

export type DeleteExtractorFailure = {
  type: typeof actionTypes.DELETE_EXTRACTOR_FAILURE;
  payload: IDeleteExtractorFailurePayload;
};

export type DeleteExtractorActions =
  | DeleteExtractorRequest
  | DeleteExtractorSuccess
  | DeleteExtractorFailure;

// PUT Extractor - API

export interface IExtractorPutReq {
  mappingAttribute: string | null,
  extPattern: IExtDataPattern,
  lndPattern: ILndDataPattern,
  stgPattern: IStgDataPattern,
  hstgPattern: IHisDataPattern,
  customSql?: string | null,
  fileRegistration?: IFileRegistration | null,
}

export interface IPutExtractorSuccess {
  extractor: boolean,
}

// state and return types

export interface IPutExtractorState {
  pending: boolean;
  extractor?: IPutExtractorSuccess | null;
  error?: IApiError | null;
}

export interface IPutExtractorSuccessPayload {
  extractor: IPutExtractorSuccess;
}

export interface IPutExtractorFailurePayload {
  error: IApiError;
}

// put action types

export type PutExtractorRequest = {
  type: typeof actionTypes.PUT_EXTRACTOR_REQUEST;
  batchCode: string;
  payload: IExtractorPutReq
}

export type PutExtractorReset = {
  type: typeof actionTypes.PUT_EXTRACTOR_RESET;
}

export type PutExtractorSuccess = {
  type: typeof actionTypes.PUT_EXTRACTOR_SUCCESS;
  payload: IPutExtractorSuccessPayload;
};

export type PutExtractorSkip = {
  type: typeof actionTypes.PUT_EXTRACTOR_SKIP;
};


export type PutExtractorFailure = {
  type: typeof actionTypes.PUT_EXTRACTOR_FAILURE;
  payload: IPutExtractorFailurePayload;
};

export type PutExtractorActions =
  | PutExtractorRequest
  | PutExtractorReset
  | PutExtractorSuccess
  | PutExtractorFailure
  | PutExtractorSkip;

  // Get Extractor Status

  export interface IExtractorStatusState {
    pending: boolean;
    extractorStatus?: ISingleExtractorStatus[] | null;
    error?: IApiError | null;
  }

  export interface ISingleExtractorStatus {
    actualLogTime: string,
    batchStart: string | null,
    isRebase: boolean | null,
    recordCount: string | null,
    status: string,
    exception: string | null,
    deltaLoad: string | null,
    runTimeInSeconds: number,
  }

  export interface FetchExtractorStatusSuccessPayload {
    extractorStatus: ISingleExtractorStatus[];
  }
  
  export interface FetchExtractorStatusFailurePayload {
    error: IApiError;
  }
  
  export interface FetchExtractorStatusReq {
    type: typeof actionTypes.FETCH_EXTRACTOR_STATUS_REQUEST;
    params: string;
  }
  
  export type FetchExtractorStatusSuccess = {
    type: typeof actionTypes.FETCH_EXTRACTOR_STATUS_SUCCESS;
    payload: FetchExtractorStatusSuccessPayload;
  };

  export type FetchExtractorStatusReset = {
    type: typeof actionTypes.FETCH_EXTRACTOR_STATUS_RESET;
  };
  
  export type FetchExtractorStatusFailure = {
    type: typeof actionTypes.FETCH_EXTRACTOR_STATUS_FAILURE;
    payload: FetchExtractorStatusFailurePayload;
  };
  
export type ExtractorStatusActions =
    | FetchExtractorStatusReq
    | FetchExtractorStatusSuccess
    | FetchExtractorStatusReset
  | FetchExtractorStatusFailure;

//Post Extractor Schema 
export interface columnGovernanceData {
  securityClassification: string,
  privacyClassification: string,
  manualTreatment: string,
  columnId: string,
  ordinal: 0,
  treatmentLevel: string
}

export interface ISchemaExtReq {
  columnGovernanceMetadata: columnGovernanceData[],
  mappingAttributes: string,
  customSql?: string,
  columns?: IColumns[] | null,
  fileRegistration?: IFileRegistration | null
}
export interface IPostExtractorSchemaSuccess {
  extractor: string,
}

// state and return types

export interface IPostSchemaExtState {
  pending: boolean;
  extractor?: IPostExtractorSchemaSuccess | null;
  error?: IApiError | null;
}

export interface IPostSchemaExtSuccessPayload {
  extractor: IPostExtractorSchemaSuccess;
}

export interface IPostSchemaExtFailurePayload {
  error: IApiError;
}

// post action types

export type PostSchemaExtRequest = {
  type: typeof actionTypes.POST_EXTRACTORSCHEMA_REQUEST;
  batchCode: string;
  payload: ISchemaExtReq
}

export type PostSchemaExtSuccess = {
  type: typeof actionTypes.POST_EXTRACTORSCHEMA_SUCCESS;
  payload: IPostSchemaExtSuccessPayload;
};

export type PostSchemaExtFailure = {
  type: typeof actionTypes.POST_EXTRACTORSCHEMA_FAILURE;
  payload: IPostSchemaExtFailurePayload;
};

export type PostSchemaExtActions =
  | PostSchemaExtRequest
  | PostSchemaExtSuccess
  | PostSchemaExtFailure;


//POST RETRY SCHEMA UPDATE

export interface IPostRetrySchemaUpdateSuccess {
  extractor: string,
}

// state and return types

export interface IPostRetrySchemaUpdateState {
  pending: boolean;
  extractor?: IPostRetrySchemaUpdateSuccess | null;
  error?: IApiError | null;
}

export interface IPostRetrySchemaUpdateSuccessPayload {
  extractor: IPostRetrySchemaUpdateSuccess;
}

export interface IPostRetrySchemaUpdateFailurePayload {
  error: IApiError;
}

// post action types

export type PostRetrySchemaUpdateRequest = {
  type: typeof actionTypes.POST_RETRYSCHEMAUPDATE_REQUEST;
  batchCode: string;
  forceValue: boolean;
}

export type PostRetrySchemaUpdateSuccess = {
  type: typeof actionTypes.POST_RETRYSCHEMAUPDATE_SUCCESS
  payload: IPostRetrySchemaUpdateSuccessPayload;
};

export type PostRetrySchemaUpdateFailure = {
  type: typeof actionTypes.POST_RETRYSCHEMAUPDATE_FAILURE;
  payload: IPostSchemaExtFailurePayload;
};

export type PostRetrySchemaUpdateActions =
  | PostRetrySchemaUpdateRequest
  | PostRetrySchemaUpdateSuccess
  | PostRetrySchemaUpdateFailure;